/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Chunk
 */
export interface Chunk {
    /**
     * 
     * @type {string}
     * @memberof Chunk
     */
    elementId: string;
    /**
     * 
     * @type {string}
     * @memberof Chunk
     */
    fieldName: string;
}

/**
 * Check if a given object implements the Chunk interface.
 */
export function instanceOfChunk(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "elementId" in value;
    isInstance = isInstance && "fieldName" in value;

    return isInstance;
}

export function ChunkFromJSON(json: any): Chunk {
    return ChunkFromJSONTyped(json, false);
}

export function ChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Chunk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elementId': json['element_id'],
        'fieldName': json['fieldName'],
    };
}

export function ChunkToJSON(value?: Chunk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'element_id': value.elementId,
        'fieldName': value.fieldName,
    };
}

